import { Translate } from 'i18n';
import { FC } from 'react';

/** The "new" pill of a new feature, after a space so "new" stays a word of its own. */
export const NewBadge: FC = () => (
  <>
    {' '}
    <span className="ln-align-middle ln-bg-[rgb(var(--ln-badge-bg))] ln-h-[24px] ln-min-w-[24px] ln-box-border ln-inline-flex ln-items-center ln-justify-center ln-px-[6px] ln-rounded-[8px] ln-text-[#000] ln-font-bold ln-text-[13px] ln-leading-[normal] ln-whitespace-nowrap ln-shrink-0 ln-lowercase">
      <Translate str="frontend.whats_new.new_tag" params={{ defaultValue: 'new' }} />
    </span>
  </>
);
